export const formatString = (str: string) => {
  return str
    .replace(/&nbsp;/g, " ")
    .replaceAll("&amp;", "&")
    .replaceAll("&lt;", "<")
    .replaceAll("&gt;", ">")
    .replaceAll("&quot;", '"')
    .replaceAll("&apos;", "'")
    .replace(/&#039;/g, "'")
    .trim();
}


export function capitalizeFirstLetter(word: string) {
  if (word.length === 0) { return word; } // 如果输入是空字符串，直接返回

  return word.charAt(0).toUpperCase() + word.slice(1);
}
